<template>
  <v-menu
    nudge-bottom="10"
    offset-y
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <div class="menu-btn">
        <v-btn v-bind="attrs" v-on="on" icon small>
          <v-icon size="20">$vuetify.icons.edit</v-icon>
        </v-btn>
        Edit
      </div>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, i) in tags"
        :class="{ 'item-selected':  selectedCar._id === item._id }"
        :key="item._id"
        @click="handleCurrentChange(item)"
      >
        <v-list-item-title class="item-content">
          <v-btn class="mr-3" icon small @click="openEditTagsDialog(item, i)">
            <v-icon size="20">$vuetify.icons.edit</v-icon>
          </v-btn>
          <b>{{ item.car_number !== 'n/a' ? item.car_number : '' }}</b>
          {{ label(item) }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
    <EditTagsDialog :visible="isShowEditTagsDialog" :tags="selectedTags" :raceId="raceId" @close="closeEditTagsDialog" @submit="submitChangeTags"/>
  </v-menu>
</template>

<script>
import EditTagsDialog from '../../components/dialogs/EditTagsDialog'
import {putImage} from '../../api/images'

export default {
  name: 'ImageInfo',
  components: {
    EditTagsDialog
  },
  props: {
    paramImageId: {
      type: String,
      required: true
    },
    tags: {
      type: Array,
      required: true
    },
    raceId: {
      type: String,
      required: true
    },
    selectedCar: {
      type: Object
    },
  },
  data() {
    return {
      isShowEditTagsDialog: false,
      selectedTags: {},
      selectedTagsCarIndex: -1
    }
  },
  methods: {
    label(tag) {
      let car_model = tag.car_model !== 'n/a' ? ` ${tag.car_model} ` : ''
      let car_orientation = tag.car_orientation !== 'n/a' ? ` ${tag.car_orientation}` : ''
      return car_orientation + car_model
    },
    openEditTagsDialog(tags, index) {
      this.selectedTags = tags
      this.selectedTagsCarIndex = index
      this.isShowEditTagsDialog = true
    },
    closeEditTagsDialog() {
      this.isShowEditTagsDialog = false
      this.selectedTags = {}
    },
    submitChangeTags(newTag) {
      const updatedeTag = {
        ...newTag,
        _id: this.tags[this.selectedTagsCarIndex]._id,
      }
      putImage(this.$route.params.imageId || this.paramImageId, [updatedeTag])
        .then(() => {
          this.$emit('update');
          this.closeEditTagsDialog();
        })
    },
    handleCurrentChange(obj) {
      this.$emit('selectCar', obj)
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  color: var(--v-grey-darken-1);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}

.item-content {
  display: flex;
  align-items: center;
  gap: 4px;
}

.item-selected {
  background-color: var(--v-blue-lighten-4);
}
</style>
